<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{ $t("tlt.qualityData.write") }}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
              <span>{{$t('tlt.qualityData.write')}}</span>
          </li>
        </ul>
      </div>
    </div>
    <section class="app-content">
      <div class="card">
        <div class="card-body">
          <form>
            <div class="row">
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityPlan.planCode')}}:</label>
                <input class="form-control" type="text" v-model="planCodeFilter" />
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityPlan.planDate')}}:</label>
                <input class="form-control" type="date" v-model="planDateStrFilter" />
              </div>

              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityPlan.planPlant')}}:</label>
                <input class="form-control" type="text" v-model="plantFilter" />
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityPlan.planShift')}}:</label>
                <input class="form-control" type="text" v-model="shiftFilter" />
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityPlan.itemName')}}:</label>
                <input class="form-control" type="text" v-model="itemNameFilter" />
              </div>
            </div>
            <div class="col-lg-12 align-self-end">
              <div class="float-lg-right">
                <button
                  class="btn btn-outline-secondary mr-1"
                  type="button"
                  v-on:click="MMFClearFilter('qualityData')"
                >
                  <i class="fa fa-fw fa-lg fa-eraser"></i>
                  <span class="text">{{ $t("btn.basic.clear") }}</span>
                </button>
                <button
                  class="btn btn-primary"
                  type="button"
                  v-on:click="loadRows()"
                >
                  <i class="fa fa-fw fa-lg fa-search"></i>
                  <span class="text">{{ $t("btn.basic.search") }}</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div id="qualityDataTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component"></div>
              <mmf-table
                entity="qualityData"
                inline-actions-disabled
                :singleChoice="true"
                disableEdit
                disableDelete
              >
                <div slot="btnList" class="btn-group" slot-scope="slotProps">
                  <button
                    :disabled="slotProps.checkedLength!=1"
                    v-bind:class="'btn btn-outline-primary btn-sm'"
                    v-on:click="Details(entity)"
                  >
                    <i class="fa fa-cog" aria-hidden="true"></i>
                    <span class="text">{{ $t("btn.qualityData.details") }}</span>
                  </button>
                </div>
              </mmf-table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import {
  gridFields,
  filterFields
} from "@/model/prd/qualityMgt/pelletizing/QualityData";
import { fields } from "@/model/prd/qualityMgt/pelletizing/QualityData";
import MmfTable from "@/components/MmfTable";
// import MmfDatetimepicker from "@/components/MmfDatetimepicker";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "qualityData/getField",
  mutationType: "qualityData/updateField"
});

export default {
  name: "qualityDataList",
  data() {
    return {
      person: ""
    };
  },
  components: { MmfTable },
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model

    ...mapFields(fields),
    ...mapFields(filterFields),
    ...mapState({
      rows: state => state.qualityData.rows,
      tableColumns: gridFields,
      entity: state => state.qualityData.entity,
      qualityResultEntity: state => state.qualityResult.entity,
      qualityPlanStatus: state => state.qualityData.qualityPlanStatus,
      baseModuleUrl: state => state.qualityData.baseModuleUrl
    })
  },
  methods: {
    ...mapActions("qualityData", ["Receive", "Details"]),
    ...mapActions("qualityResult", ["Check"]),
    ...mapActions("base", [
      "MMFselectRow",
      "MMFselectAllRows",
      "MMFNew",
      "MMFEdit",
      "MMFLoadRows",
      "MMFDelete",
      "MMFClearFilter"
    ]),
    receive(moudle) {
      this.entity.checkPerson = this.person;
      this.Receive(moudle);
    },
    clear() {
      this.person = "";
    },
      loadRows(){
       this.planDateStrFilter = null;
       this.statusFilter="R";
       this.MMFLoadRows('qualityData');
    }
  },
  mounted(){
    this.loadRows();
  }
  
};
</script>
